"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Dropdown;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _noop2 = _interopRequireDefault(require("lodash/noop"));

var _Popover = _interopRequireDefault(require("../Popover"));

var _dropdownModule = _interopRequireDefault(require("./dropdown.module.css"));

var _excluded = ["options", "onSelectOption"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Dropdown(_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$onSelectOption = _ref.onSelectOption,
      onSelectOption = _ref$onSelectOption === void 0 ? _noop2.default : _ref$onSelectOption,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_Popover.default, props, function (popoverProps) {
    var handleClick = function handleClick(option) {
      return function () {
        onSelectOption(option);
        popoverProps === null || popoverProps === void 0 ? void 0 : popoverProps.onTriggerClick();
      };
    };

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(_dropdownModule.default.dropdown, " bg-white ml-2")
    }, options.map(function (option) {
      var label = option.label;
      return /*#__PURE__*/_react.default.createElement("div", {
        key: label,
        onClick: handleClick(option),
        onKeyDown: handleClick(option),
        tabIndex: 0,
        role: "button",
        className: _dropdownModule.default.dropdownItem
      }, /*#__PURE__*/_react.default.createElement("div", {
        "aria-hidden": "true",
        tabIndex: "0",
        role: "button"
      }, /*#__PURE__*/_react.default.createElement("span", null, label)));
    }));
  });
}

Dropdown.propTypes = {
  options: _propTypes.default.array,
  onSelectOption: _propTypes.default.func
};